export const ARTICLE_PLAGIARISM_CHECK_STATUSES = {
  SUCCESS: 'success',
  CHECKING: 'checking',
  ERROR: 'error',
}
